<template>
  <v-toolbar dense flat fixed class="minitoolbar">
        <div v-if="!listMode && !isPadBool" class="d-flex justify-space-between align-center ml-n4 pb-2 pt-3"
        :class="!ShowJobs || 'tab'">
        <!-- border-right: 4px solid #e5e5e8; -->
        <v-btn v-if="!listMode" :color="ShowJobs ? 'tertiary' : ''" small icon id="showjobsbtn"
            :class="ShowJobs ? 'active' : ''" class="mx-4" @click="ShowJobs = !ShowJobs">
            <v-icon v-text="'mdi-briefcase-eye'" />
        </v-btn>
        <v-spacer/>
        <QAutoComplete v-if="ShowJobs" v-model="FilterStatus" :label="$t('servicesystem.common_objects.job.status')"
            :list="statuses" :textkey="'Name'" :valuekey="'Id'" :rules="[requiredRule]" :externaledit="true" class="mx-3"
            singleline>
            <template v-slot:item="{ item }">
            <v-list-item-content>
                {{ item.Name }}
            </v-list-item-content>
            <v-list-item-icon class="mx-0 my-auto">
                <CardBadge :color="'primary'" :count="item.Count" :index="0">
                </CardBadge>
                <CardBadge :color="'#4397E8'" :count="substatusCount(item.Id)" :index="1">
                </CardBadge>
            </v-list-item-icon>
            </template>
        </QAutoComplete>
        </div>
    </v-toolbar>
</template>
<script>

import CardBadge from "@/components/Buttons/CardBadge.vue";
export default {
    name: "JobsToolbar",
    components: {
        CardBadge,
    },
    methods: {
        substatusCount(parentStatusId) {
            var list = Object.assign([], this.$store.getters["LookUpStore/JobSubStatusListByParent"](parentStatusId));
            var count = 0;
            list.forEach((x) => {
                count += x.Count;
            });
            return count;
        },
        async getjobs() {
            await this.$store.dispatch("plannerstore/GetUnplannedJobs");
        },
    },
    computed: {
        listMode() {
            return this.Mode == 'List';
        },  
        FilterStatus: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("PlannerJobListStatusFilter");
            },
            set(update) {
                //console.log(update);
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListStatusFilter", value: update });
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListSubStatusFilter", value: null });
                this.getjobs();
            },
        },
        statuses() {
            var statuses = Object.assign([], this.$store.getters["LookUpStore/JobStatusList"]);
            var filteredstatuses = statuses.filter((y) => y.Id < 70);

            return filteredstatuses;
        },
        ShowJobs: {
            get() {
                return this.$store.getters["prefrences/Prefrence"]("PlannerJobListShow");
            },
            set(update) {
                this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListShow", value: update });
            },
        }
    }
};
</script>